import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const items = [
  { name: "Programme PDF de 21 nuits", detail: "Guide progressif, jour par jour" },
  { name: "Journal du sommeil imprimable", detail: "Suivi de tes soirées & réveils" },
  { name: "Exercices de respiration", detail: "Fiches pratiques illustrées" },
  { name: "7 relaxations guidées audio", detail: "Voix douce, format mp3" },
  { name: "3 ambiances sonores longues", detail: "Pluie, forêt, nuit d’été" },
  { name: "Module SOS sommeil", detail: "Pour les réveils nocturnes" },
  { name: "Tracker d’habitudes", detail: "Version web app (Premium)" },
  { name: "Recommandations quotidiennes", detail: "Personnalisées (Premium)" },
];

export const Included = () => {
  return (
    <section
      id="included"
      data-testid="included-section"
      className="relative mx-auto max-w-4xl scroll-mt-24 px-6 py-24 md:py-32 lg:px-10"
    >
      <Reveal className="mb-14">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          Ce que tu reçois
        </p>
        <h2 className="text-4xl font-light leading-tight tracking-tight sm:text-5xl">
          Tout est inclus, prêt dès ce soir
        </h2>
      </Reveal>

      <div className="flex flex-col">
        {items.map((it, i) => (
          <Reveal
            key={it.name}
            delay={i * 0.05}
            className="group flex items-center justify-between gap-4 border-b border-white/10 py-6 transition-colors duration-300 hover:border-[#c9a84c]/30"
          >
            <div className="flex items-start gap-4">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full border border-[#c9a84c]/30 text-[#c9a84c]">
                <Check className="h-3.5 w-3.5" strokeWidth={2.2} />
              </span>
              <div>
                <p className="text-base text-white/90 sm:text-lg">{it.name}</p>
                <p className="mt-1 text-sm text-white/45">{it.detail}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
